import '../scss/style.scss';


if (window.jQuery) {
   jQuery(function ($) {
      $('.wpf-disable-field input, .wpf-disable-field textarea').attr({
         readonly: "readonly",
         tabindex: "-1"
      });
   });
}


document.addEventListener('DOMContentLoaded', function () {
   function isOurServicesTrigger(element) {
      if (!element || !element.matches('.elementor-item')) return false;

      const linkText = element.textContent.trim().toLowerCase();
      const linkTitle = (element.getAttribute('title') || '').trim().toLowerCase();

      return linkTitle === 'our services' || linkText === 'our services';
   }

   function setServicesMenuState(menuList, trigger, subItems, isOpen) {
      trigger.setAttribute('aria-expanded', String(isOpen));
      trigger.classList.toggle('is-services-trigger-open', isOpen);
      menuList.classList.toggle('is-services-open', isOpen);

      subItems.forEach(function (item) {
         item.classList.toggle('submenu-open', isOpen);
         item.hidden = !isOpen;
         item.style.display = isOpen ? 'flex' : 'none';
      });
   }

   function initMobileServicesMenu() {
      const mobileMenus = document.querySelectorAll('.menu__mobile');
      if (!mobileMenus.length) return;

      mobileMenus.forEach(function (menuMobile) {
         const ourServicesLinks = menuMobile.querySelectorAll('.elementor-item[title="Our Services"], .elementor-item[href="#"]');

         if (!ourServicesLinks.length) return;

         ourServicesLinks.forEach(function (ourServicesLink) {
            if (!isOurServicesTrigger(ourServicesLink)) return;

            const menuList = ourServicesLink.closest('.elementor-nav-menu');
            if (!menuList) return;

            const subItems = menuList.querySelectorAll('.elementor-sub-item');
            if (!subItems.length) return;

            ourServicesLink.setAttribute('role', 'button');
            ourServicesLink.setAttribute('aria-haspopup', 'true');

            if (ourServicesLink.getAttribute('aria-expanded') !== 'true') {
               setServicesMenuState(menuList, ourServicesLink, subItems, false);
            }
         });
      });
   }

   document.addEventListener('click', function (e) {
      const ourServicesLink = e.target.closest('.menu__mobile .elementor-item');
      if (!isOurServicesTrigger(ourServicesLink)) return;

      const menuList = ourServicesLink.closest('.elementor-nav-menu');
      if (!menuList) return;

      const subItems = menuList.querySelectorAll('.elementor-sub-item');
      if (!subItems.length) return;

      e.preventDefault();
      e.stopPropagation();

      const isOpen = ourServicesLink.getAttribute('aria-expanded') === 'true';
      setServicesMenuState(menuList, ourServicesLink, subItems, !isOpen);
   }, true);

   initMobileServicesMenu();

   const observer = new MutationObserver(initMobileServicesMenu);
   observer.observe(document.body, {
      childList: true,
      subtree: true
   });
});


document.addEventListener('DOMContentLoaded', function () {
  const currentPath = window.location.pathname.replace(/\/$/, '');
  const lists = document.querySelectorAll('.areas__services-list');

  lists.forEach(function (list) {
    const items = list.querySelectorAll('.elementor-icon-list-item');
    items.forEach(function (item) {
      const link = item.querySelector('a');
      if (!link) return;

      const linkPath = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, '');

      if (linkPath === currentPath) {
        item.classList.add('active');
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
   const yearSpan = document.getElementById('year');
   if (!yearSpan) return;

   const currentYear = new Date().getFullYear();
   yearSpan.textContent = currentYear;
});


document.addEventListener('DOMContentLoaded', function () {
   document.querySelectorAll('.service__excerpt .elementor-widget-container').forEach(p => {
      p.innerHTML = p.innerHTML.replace(/<br\s*[\/]?>/gi, "");
    });
});


document.addEventListener('DOMContentLoaded', function() {
   var waitForSwiper = function(selector, callback) {
       var element = document.querySelector(selector);
       if (element && element.swiper) {
           callback(element.swiper);
       } else {
           setTimeout(function() {
               waitForSwiper(selector, callback);
           }, 100);
       }
   };

   waitForSwiper('.home__carousel--hero .swiper', function(swiper) {
       var hasAutoplay = swiper.params.autoplay !== false && swiper.params.autoplay !== undefined;

       swiper.params = Object.assign({}, swiper.params, {
           loop: true,
           loopAdditionalSlides: 1,
           parallax: true,
           autoplay: hasAutoplay ? {
               delay: 5000,
               disableOnInteraction: false,
               pauseOnMouseEnter: true
           } : false,
           speed: 1000
       });

       swiper.update();

       if (hasAutoplay) {
           swiper.el.addEventListener('mouseenter', function() {
               if (swiper.autoplay && swiper.autoplay.pause) {
                   swiper.autoplay.pause();
               }
           });

           swiper.el.addEventListener('mouseleave', function() {
               if (swiper.autoplay && swiper.autoplay.run) {
                   swiper.autoplay.run();
               }
           });
       }
   });
});


const currentYear = new Date().getFullYear();
console.log(`Caribbean Watershed Conservation Theme ${currentYear} - By Yoan Sierra Tejeda`);
